// @flow
import * as React from 'react'
import { withRouter } from 'react-router-dom'
import RegisterIncentives from 'components/RegisterIncentives'
import RegisterForm from 'components/RegisterForm'

import { Store } from 'Store'

import Layout from 'components/Layout'

type Props = {
    location: Location
}

export default withRouter((props: Props) => {
    const { dispatch } = React.useContext(Store)
    React.useMemo(() => props.history.listen(() => {
        if (window.location.pathname.split('/').length === 2) {
            dispatch({
                type: 'SET_LEAD',
                payload: null
            })
        }
    }), [props.history, dispatch])

    return (
        <Layout>
            <RegisterForm/>
            <RegisterIncentives/>
        </Layout>
    )
})
